import { WebinarContentSummary } from '@core/swagger-client';
import { WebinarStatus } from '@core/types';
import { EyeOpen, Users } from '@core/ui';
import { useTranslation } from 'react-i18next';
import { WebinarDataItem } from '../../atoms';

export const WebinarDataFollowers = ({ webinar }: { webinar: WebinarContentSummary }) => {
    const { t } = useTranslation();

    return (
        <>
            {webinar.status !== WebinarStatus.Ended && (
                <WebinarDataItem
                    classNames="me-auto"
                    data={webinar.numberOfInterested}
                    icon={<Users />}
                    subject={t('Webinar.Data.Interested')}
                    to="/$webinarId/interested-accounts"
                    params={{ webinarId: webinar.webinarId }}
                    state={{ backTo: 'overview' }}
                />
            )}
            {((webinar.status === WebinarStatus.Planned && webinar.numberOfOnlineParticipants > 0) || webinar.status === WebinarStatus.Started) && (
                <WebinarDataItem
                    classNames="me-auto"
                    data={webinar.numberOfOnlineParticipants}
                    icon={<Users />}
                    subject={t('Webinar.Data.Viewers')}
                    to="/$webinarId/live-participants"
                    params={{ webinarId: webinar.webinarId }}
                    state={{ backTo: 'overview' }}
                />
            )}
            {webinar.status === WebinarStatus.Ended && (
                <WebinarDataItem
                    classNames="me-auto"
                    data={webinar.numberOfOnDemandParticipants}
                    icon={<EyeOpen />}
                    subject={t('Webinar.Data.OndemandViews')}
                    to="/$webinarId/on-demand-participants"
                    params={{ webinarId: webinar.webinarId }}
                    state={{ backTo: 'overview' }}
                />
            )}
        </>
    );
};
